const mql = window.matchMedia("(min-width: 992px)");
const transformation = document.querySelector('.transformation--left');
if(transformation && mql.matches) {
	const leftAlignment = transformation.querySelector(".row").getBoundingClientRect().left;
	const offsetItems = document.querySelectorAll('.content-synopsis.text-left,.content-intro.text-left,.content-base')
	offsetItems.forEach(item => {
		const diff = leftAlignment - item.getBoundingClientRect().left
		item.style.marginLeft = `${diff}px`
	})
}